var CountryListController = (function () {
    function CountryListController($state, settings, env, socket, $scope, Dialog, admin) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.visibleMax = 7;
        this.isSaving = false;
        this.docTableOrig = {};
        this.docTable = [];
        this.countryTable = [];
        this.isDivisionLoaded = false;
        this.isCountryLoaded = false;
        this.newCode = {
            isLineValid: true
        };
        this.socket.forward('validationview.ctyList', this.$scope);
        this.$scope.$on('socket:validationview.ctyList', function (event, data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].ic === 'Country') {
                    _this.countryTable.push(data[i]);
                }
            }
            _this.isCountryLoaded = true;
        });
        this.socket.forward('validationview.countryList', this.$scope);
        this.$scope.$on('socket:validationview.countryList', function (event, data) {
            data.isValid = true;
            for (var i2 = 0; i2 < data.currentTable.length; i2++) {
                data.currentTable[i2].isLineValid = true;
                data.currentTable[i2].reqStart = new Date(data.currentTable[i2].reqStart);
                data.currentTable[i2].reqEnd = new Date(data.currentTable[i2].reqEnd);
            }
            data.origTable = JSON.parse(JSON.stringify(data.currentTable));
            for (var i2 = 0; i2 < data.colNames.length; i2++) {
                _this.newCode[data.colNames[i2].colKey] = '';
            }
            _this.docTable = data;
            _this.docTableOrig = JSON.parse(JSON.stringify(data));
            _this.isDivisionLoaded = true;
            if (_this.isSaving) {
                //Once done saving, send email to Admin team
                var emailBundle = { docurl: 'country-view', profile: 'Country Profile', user: _this.env.user };
                _this.admin.sendAdminUpdate(emailBundle);
            }
            _this.alphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');
            // migration from exchange rate to country listing
            /* for (let j: number = 0; j < this.docTable.currentTable.length; j++) {
                delete this.docTable.currentTable[j].crncyToUSD;
                delete this.docTable.currentTable[j].usdToCrncy;
            } */
            _this.sortCurrentTable();
            var coord;
            coord = _this.activeLetter
                ? _this.findEndPoints(_this.activeLetter)
                : _this.findEndPoints('A');
            _this.visibleStart = coord[0];
            _this.visibleEnd = coord[1];
            _this.visibleTable = _this.docTable.currentTable.slice(_this.visibleStart, _this.visibleEnd);
            _this.isSaving = false;
        });
    }
    CountryListController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryList',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
        this.cfg = {
            decPlaces: [
                { value: '0', label: '0' },
                { value: '1', label: '1' },
                { value: '2', label: '2' },
            ],
            incType: [
                { value: 'CVR - Sales', label: 'CVR - Sales' },
                { value: 'CVR - Sales Assist', label: 'CVR - Sales Assist' },
                { value: 'All', label: 'All' },
            ],
            licType: [
                { value: 'License', label: 'License' },
                { value: 'Monthly', label: 'Monthly' },
                { value: 'SaaS', label: 'SaaS' },
                { value: 'All', label: 'All' },
            ],
            yesNo: [
                { value: 'Yes', label: 'Yes' },
                { value: 'No', label: 'No' },
            ]
        };
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    CountryListController.prototype.addNewCode = function () {
        this.checkValidityNewCode(this.docTable);
        if (!this.newCode.isLineValid) {
            alert('Please fix the issues before saving');
            this.docTable.isValid = true;
            this.isSaving = false;
        }
        else {
            var addLine = {};
            var addText = '';
            for (var key in this.newCode) {
                for (var i = 0; i < this.docTable.colNames.length; i++) {
                    if (key === this.docTable.colNames[i].colKey) {
                        addLine[key] = this.newCode[key];
                        if (key !== 'reqStart' && key !== 'reqEnd') {
                            if (addText === '') {
                                addText = this.newCode[key];
                            }
                            else {
                                addText = addText + ', ' + this.newCode[key];
                            }
                        }
                    }
                }
            }
            addLine.reqStart = new Date(addLine.reqStart);
            addLine.reqEnd = new Date(addLine.reqEnd);
            var startText = addLine.reqStart.getDate() + '.' + (addLine.reqStart.getMonth() + 1) + '.' + addLine.reqStart.getFullYear();
            var endText = addLine.reqEnd.getDate() + '.' + (addLine.reqEnd.getMonth() + 1) + '.' + addLine.reqEnd.getFullYear();
            var historyGen = ['Entry created: ' + addText + ', ' + startText + ', ' + endText];
            var timeStamp = new Date();
            var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
            var oneHist = {
                timestamp: timeText,
                comment: historyGen,
                user: this.env.user.email
            };
            this.docTable.tableHistory.push(oneHist);
            this.docTable.currentTable.push(addLine);
            this.voidNew(this.docTable);
            this.checkValidity(this.docTable);
            this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
            delete this.docTableOrig.origTable;
            this.docTable.origTable = JSON.parse(JSON.stringify(this.docTable.currentTable));
            this.isSaving = true;
            this.sendforUpdate(historyGen);
        }
    };
    CountryListController.prototype.voidNew = function (oneTab) {
        if (oneTab) {
            this.curTab = oneTab;
            this.newCode = {
                isLineValid: true
            };
            for (var i2 = 0; i2 < oneTab.colNames.length; i2++) {
                this.newCode[oneTab.colNames[i2].colKey] = '';
            }
        }
        else {
            for (var property in this.newCode) {
                if (this.newCode.hasOwnProperty(property)) {
                    this.newCode[property] = '';
                }
            }
            this.newCode.isLineValid = true;
        }
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    CountryListController.prototype.checkValidity = function (oneTab) {
        oneTab.isValid = true;
        for (var i = 0; i < oneTab.currentTable.length; i++) {
            oneTab.currentTable[i].isLineValid = true;
        }
        // check mandatory - for the new fields
        var reqFields = ['licType', 'incType', 'primCur', 'vatUsed', 'decPlaces', 'fcUplift', 'cvrElig'];
        for (var i = 0; i < oneTab.currentTable.length; i++) {
            for (var key in oneTab.currentTable[i]) {
                // if (key.search('req') > -1 && key !== 'reqStart' && key !== 'reqEnd') {
                if (reqFields.indexOf(key) !== -1) {
                    if (oneTab.currentTable[i][key] === '') {
                        oneTab.currentTable[i].isLineValid = false;
                        oneTab.isValid = false;
                        break;
                    }
                    if (key === 'fcUplift') {
                        if (Number(oneTab.currentTable[i][key]) < 0 || Number(oneTab.currentTable[i][key]) > 100) {
                            oneTab.currentTable[i].isLineValid = false;
                            oneTab.isValid = false;
                            break;
                        }
                    }
                    // check if pri currency is three letter code only
                    if (key === 'primCur') {
                        if (oneTab.currentTable[i][key] !== '-') {
                            if (oneTab.currentTable[i][key].length !== 3) {
                                oneTab.currentTable[i].isLineValid = false;
                                oneTab.isValid = false;
                                break;
                            }
                            else {
                                if (!(/^[a-zA-Z]+$/.test(oneTab.currentTable[i][key]))) {
                                    oneTab.currentTable[i].isLineValid = false;
                                    oneTab.isValid = false;
                                    break;
                                }
                            }
                        }
                    }
                    // check if forecast uplift is a number between 0 to 100
                    if (key === 'fcUplift') {
                        if (oneTab.currentTable[i][key] !== '-') {
                            if (!Number(oneTab.currentTable[i][key])) {
                                oneTab.currentTable[i].isLineValid = false;
                                oneTab.isValid = false;
                                break;
                            }
                            else if (Number(oneTab.currentTable[i][key]) < 0 || Number(oneTab.currentTable[i][key]) > 100) {
                                oneTab.currentTable[i].isLineValid = false;
                                oneTab.isValid = false;
                                break;
                            }
                        }
                    }
                }
            }
        }
        for (var i = 0; i < oneTab.currentTable.length - 1; i++) {
            if (!(oneTab.currentTable[i].reqStart instanceof Date) || !(oneTab.currentTable[i].reqEnd instanceof Date)) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else if (oneTab.currentTable[i].reqStart > oneTab.currentTable[i].reqEnd) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else {
                for (var i2 = i + 1; i2 < oneTab.currentTable.length; i2++) {
                    var perfectFit = true;
                    var checkFit = false;
                    for (var key in oneTab.currentTable[i]) {
                        if (key.search('combo') > -1) {
                            checkFit = true;
                            if (oneTab.currentTable[i][key] !== oneTab.currentTable[i2][key]) {
                                perfectFit = false;
                                break;
                            }
                        }
                    }
                    if ((oneTab.currentTable[i].reqCode === oneTab.currentTable[i2].reqCode && typeof oneTab.currentTable[i].reqCode !== 'undefined')
                        || (oneTab.currentTable[i].country === oneTab.currentTable[i2].country && typeof oneTab.currentTable[i].country !== 'undefined')
                        || (perfectFit && checkFit)) {
                        if ((oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= oneTab.currentTable[i].reqEnd)) {
                            oneTab.currentTable[i].isLineValid = false;
                            oneTab.currentTable[i2].isLineValid = false;
                            oneTab.isValid = false;
                        }
                    }
                }
            }
        }
    };
    CountryListController.prototype.checkValidityNewCode = function (oneTab) {
        var reqFields = ['licType', 'incType', 'primCur', 'vatUsed', 'decPlaces', 'fcUplift', 'cvrElig'];
        oneTab.isValid = true;
        this.newCode.isLineValid = true;
        // check license and incentive type and clear threshold accordingly 
        // if (this.newCode.licType === 'License' && this.newCode.incType === 'CVR - Sales Assist'){
        //    this.newCode.ctyThreshold = '';
        // }
        // check for mandatory, new fields
        for (var key in this.newCode) {
            if (reqFields.indexOf(key) !== -1) {
                if (this.newCode[key] === '') {
                    this.newCode.isLineValid = false;
                    break;
                }
            }
        }
        // check country for duplicates
        if (this.newCode.isLineValid) {
            for (var i = 0; i < this.docTable.currentTable.length; i++) {
                if (this.newCode.combocountry === this.docTable.currentTable[i].combocountry) {
                    this.newCode.isLineValid = false;
                    break;
                }
            }
        }
        // check if pri currency is three letter code only
        if (this.newCode.isLineValid) {
            if (this.newCode.primCur.length !== 3) {
                this.newCode.isLineValid = false;
            }
            else {
                if (!(/^[a-zA-Z]+$/.test(this.newCode.primCur))) {
                    this.newCode.isLineValid = false;
                }
            }
        }
        // check if forecast uplift is a number between 0 to 100
        if (this.newCode.isLineValid) {
            if (!Number(this.newCode.fcUplift)) {
                this.newCode.isLineValid = false;
            }
            else {
                if (Number(this.newCode.fcUplift) < 0 || Number(this.newCode.fcUplift) > 100) {
                    this.newCode.isLineValid = false;
                }
            }
        }
        if (this.newCode.isLineValid) {
            if ((this.newCode.reqStart > this.newCode.reqEnd)) {
                this.newCode.isLineValid = false;
                oneTab.isValid = false;
            }
            else if (Number(this.newCode.fcUplift) < 0 || Number(this.newCode.fcUplift) > 100) {
                this.newCode.isLineValid = false;
                oneTab.isValid = false;
            }
            else if (oneTab.currentTable.length > 0) {
                for (var i2 = 0; i2 < oneTab.currentTable.length; i2++) {
                    var perfectFit = true;
                    var checkFit = false;
                    for (var key in this.newCode) {
                        if (key.search('combo') > -1) {
                            checkFit = true;
                            if (this.newCode[key] !== oneTab.currentTable[i2][key]) {
                                perfectFit = false;
                                break;
                            }
                        }
                    }
                    if ((this.newCode.reqCode === oneTab.currentTable[i2].reqCode && typeof this.newCode.reqCode !== 'undefined') || (perfectFit && checkFit)) {
                        if ((this.newCode.reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < this.newCode.reqEnd)
                            || (this.newCode.reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < this.newCode.reqEnd)
                            || (this.newCode.reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= this.newCode.reqEnd)) {
                            this.newCode.isLineValid = false;
                            oneTab.currentTable[i2].isLineValid = false;
                            oneTab.isValid = false;
                        }
                    }
                }
            }
        }
    };
    CountryListController.prototype.deleteConfirmation = function (ev, oneItem) {
        var _this = this;
        this.Dialog.confirmDelete(ev, oneItem).then(function (dResult) {
            //        this.Dialog.updateValidForm(event, this.toDelete, 'sampling.html').then((dResult: any) => {
            if (dResult) {
                _this.deleteLine(oneItem);
            }
        });
    };
    CountryListController.prototype.deleteLine = function (oneItem) {
        var curPosItem = this.docTable.currentTable.indexOf(oneItem);
        var startDate = new Date(this.docTable.origTable[curPosItem].reqStart);
        var startText = startDate.getDate() + '.' + (startDate.getMonth() + 1) + '.' + startDate.getFullYear();
        var endDate = new Date(this.docTable.currentTable[curPosItem].reqEnd);
        var endText = endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var comment = 'Deleted: ';
        for (var key in this.docTable.currentTable[curPosItem]) {
            if (key !== 'reqStart' && key !== 'reqEnd' && key !== 'isLineValid') {
                comment += this.docTable.currentTable[curPosItem][key] + ', ';
            }
        }
        var oneHist = {
            timestamp: timeText,
            comment: [comment + ', start ' + startText + ', end ' + endText],
            user: this.env.user.email
        };
        this.docTable.tableHistory.push(oneHist);
        this.docTable.currentTable.splice(curPosItem, 1);
        this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
        for (var i = 0; i < this.docTable.length; i++) {
            delete this.docTableOrig.origTable;
            this.docTable.origTable = JSON.parse(JSON.stringify(this.docTable.currentTable));
        }
        this.isSaving = true;
        this.sendforUpdate(oneHist.comment);
    };
    CountryListController.prototype.save = function () {
        this.checkValidity(this.docTable);
        if (!this.docTable.isValid) {
            alert('Please fix the issues before saving');
            this.docTable.isValid = true;
            this.isSaving = false;
        }
        else {
            var historyGen = [];
            var commentBase = [];
            if (typeof this.docTable.origTable[0].reqCode === 'undefined') {
                for (var key in this.docTable.origTable[0]) {
                    if (key.search('combo') > -1) {
                        commentBase.push(key);
                    }
                }
            }
            else {
                commentBase.push(this.docTable.origTable[0].reqCode);
            }
            for (var i2 = 0; i2 < this.docTable.currentTable.length; i2++) {
                for (var key in this.docTable.currentTable[i2]) {
                    if (key === '$$hashKey') {
                        delete this.docTable.currentTable[i2][key];
                    }
                    else if (this.docTable.origTable[i2][key] !== this.docTable.currentTable[i2][key]) {
                        var colName = '';
                        var isDate = false;
                        if (key === 'reqStart' || key === 'reqEnd') {
                            isDate = true;
                        }
                        var mainText = '';
                        for (var iBase = 0; iBase < commentBase.length; iBase++) {
                            if (iBase === 0) {
                                mainText = this.docTable.origTable[i2][commentBase[iBase]];
                            }
                            else {
                                mainText = mainText + ', ' + this.docTable.origTable[i2][commentBase[iBase]];
                            }
                        }
                        if (!isDate) {
                            historyGen.push(mainText + ', ' + colName + ' changed from ' + this.docTable.origTable[i2][key] + ' to ' + this.docTable.currentTable[i2][key]);
                        }
                        else {
                            var orDate = new Date(this.docTable.origTable[i2][key]);
                            var orText = orDate.getDate() + '.' + (orDate.getMonth() + 1) + '.' + orDate.getFullYear();
                            var curDate = new Date(this.docTable.currentTable[i2][key]);
                            var curText = curDate.getDate() + '.' + (curDate.getMonth() + 1) + '.' + curDate.getFullYear();
                            if (orText !== curText) {
                                historyGen.push(mainText + ', ' + colName + ' changed from ' + orText + ' to ' + curText);
                            }
                        }
                    }
                }
            }
            if (historyGen.length > 0) {
                var timeStamp = new Date();
                var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
                var oneHist = {
                    timestamp: timeText,
                    comment: historyGen,
                    user: this.env.user.email
                };
                this.docTable.tableHistory.push(oneHist);
                this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
                delete this.docTableOrig.origTable;
                this.docTable.origTable = JSON.parse(JSON.stringify(this.docTable.currentTable));
                this.isSaving = true;
                this.sendforUpdate(historyGen);
            }
        }
    };
    CountryListController.prototype.sendforUpdate = function (historyText) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendCountryListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTableOrig,
                receivers: ['roman.tibensky@sk.ibm.com'],
                historyText: historyText
            }
        });
    };
    CountryListController.prototype.activateLetter = function (letter) {
        var points;
        this.activeLetter = letter;
        points = this.findEndPoints(letter);
        this.visibleStart = points[0]; // += this.visibleMax;
        this.visibleEnd = points[1]; // += this.visibleMax;
        /*this.visibleEnd = this.visibleEnd > this.docTable.currentTable.length
        ? this.docTable.currentTable.length
        : this.visibleEnd;*/
        this.visibleTable = this.docTable.currentTable.slice(this.visibleStart, this.visibleEnd);
    };
    CountryListController.prototype.sortCurrentTable = function () {
        var tmpObj;
        var obj_1;
        var obj_2;
        for (var i = 0; i < this.docTable.currentTable.length; i++) {
            for (var j = 0; j < this.docTable.currentTable.length; j++) {
                obj_1 = this.docTable.currentTable[i];
                obj_2 = this.docTable.currentTable[j];
                if (this.docTable.currentTable[j].combocountry > this.docTable.currentTable[i].combocountry) {
                    tmpObj = this.docTable.currentTable[i];
                    this.docTable.currentTable[i] = this.docTable.currentTable[j];
                    this.docTable.currentTable[j] = tmpObj;
                }
            }
        }
    };
    CountryListController.prototype.findEndPoints = function (letter) {
        var result = [];
        var i;
        for (i = 0; i < this.docTable.currentTable.length; i++) {
            if (this.docTable.currentTable[i].combocountry.charAt(0) === letter) {
                break;
            }
        }
        result.push(i);
        for (i = result[0]; i < this.docTable.currentTable.length; i++) {
            if (this.docTable.currentTable[i].combocountry.charAt(0) !== letter) {
                break;
            }
        }
        result.push(i);
        return (result);
    };
    CountryListController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return CountryListController;
}());
var CountryListComponent = (function () {
    function CountryListComponent() {
        this.templateUrl = 'country-view.html';
        this.controllerAs = 'vm';
        this.controller = CountryListController;
    }
    return CountryListComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewCountrySection', new CountryListComponent());

//# sourceMappingURL=country.view.component.js.map
